<template>
  <aside class="w-full sm:w-64 space-y-2">
    <div class="bg-white shadow rounded-lg p-4">
      <h2 class="text-lg font-semibold mb-4">Kategori</h2>
      <div v-for="category in categories" :key="category" class="flex items-center space-x-2 mb-2">
        <input
          type="checkbox"
          :id="category"
          :value="category"
          v-model="selectedCategories"
          @change="emitFilters"
          class="rounded text-blue-500 focus:ring-blue-500"
        />
        <label :for="category" class="text-sm font-medium text-gray-700">{{ category }}</label>
      </div>
    </div>
    <div class="bg-white shadow rounded-lg p-4">
      <h2 class="text-lg font-semibold mb-4">Merek</h2>
      <div v-for="brand in brands" :key="brand" class="flex items-center space-x-2 mb-2">
        <input
          type="checkbox"
          :id="brand"
          :value="brand"
          v-model="selectedBrands"
          @change="emitFilters"
          class="rounded text-blue-500 focus:ring-blue-500"
        />
        <label :for="brand" class="text-sm font-medium text-gray-700">{{ brand }}</label>
      </div>
    </div>
    <div class="bg-white shadow rounded-lg p-4">
      <h2 class="text-lg font-semibold mb-4">Tipe AC</h2>
      <div v-for="type in types" :key="type" class="flex items-center space-x-2 mb-2">
        <input
          type="checkbox"
          :id="type"
          :value="type"
          v-model="selectedTypes"
          @change="emitFilters"
          class="rounded text-blue-500 focus:ring-blue-500"
        />
        <label :for="type" class="text-sm font-medium text-gray-700">{{ type }}</label>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    brands: {
      type: Array,
      required: true
    },
    types: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedBrands: [],
      selectedTypes: [],
      selectedCategories: []
    }
  },
  methods: {
    emitFilters() {
      this.$emit('filter', {
        brands: this.selectedBrands,
        types: this.selectedTypes,
        categories: this.selectedCategories
      })
    }
  }
}
</script>